export class Show {
    public static readonly type: string = '[Loading Bar] Show';
    constructor(public path: string) { }
}

export class Hide {
    public static readonly type: string = '[Loading Bar] Hide';
}
